export const BILL_TYPE = {
  DEPOSIT: '充值',
  WITHDRAW: '提现',
  CANCEL_WITHDRAW: '取消提现',
  CREATE_TRADE: '交易下单',
  CANCEL_TRADE: '交易撤单',
  TRADE_DEAL: '交易撮合',
  DIVIDEND_TRANSFER: '分红转账',
  FOUNDATION_FINANCING: '用户抢购',
  FOUNDATION_INVITE_REWARD: '抢购推荐奖励'
};
